import React from "react";

import { Experimental_CssVarsProvider as CssVarsProvider } from "@mui/material/styles";
import { StylesProvider, createGenerateClassName } from "@mui/styles";
import { useCustomerPortalColorScheme } from "Hooks/useCustomerPortalColorScheme";
import { Redirect, Route, Switch } from "react-router-dom";

import { CUSTOMER_PORTAL_PUBLIC_ROUTES } from "../constants";
import { useAppState } from "../context/StateContext";
import { CustomerPortal } from "../pages/private/Moving/CustomerPortal";
import CustomerPortalForgotPassword from "../pages/public/CustomerPortalForgotPassword";
import CustomerPortalLogin from "../pages/public/CustomerPortalLogin";
import CustomerPortalUpdatePassword from "../pages/public/CustomerPortalUpdatePassword";
import { useCustomerPortalStore } from "../stores/customerPortal/customerPortalStore";

const generateClassName = createGenerateClassName({
  productionPrefix: "cp-",
  seed: "customer-portal",
});

export const CustomerPortalApp = () => {
  document.title = "Customer Portal | Shipeezi";

  useCustomerPortalColorScheme();

  const { currentCustomerUser } = useAppState();
  const theme = useCustomerPortalStore((state) => state.theme);

  const PublicRoutes = () => (
    <Switch>
      <Route path="/" exact component={CustomerPortalLogin} />
      <Route
        path={CUSTOMER_PORTAL_PUBLIC_ROUTES.EMAIL_CONFIRMATION}
        exact
        component={CustomerPortalUpdatePassword}
      />
      <Route
        path={CUSTOMER_PORTAL_PUBLIC_ROUTES.FORGOT}
        exact
        component={CustomerPortalForgotPassword}
      />
      <Route>
        <Redirect to="/" />
      </Route>
    </Switch>
  );

  const PrivateRoutes = () => (
    <Switch>
      <Route
        path={CUSTOMER_PORTAL_PUBLIC_ROUTES.EMAIL_CONFIRMATION}
        component={CustomerPortalUpdatePassword}
        exact
      />
      <Route path="/" component={CustomerPortal} />
    </Switch>
  );

  return (
    <CssVarsProvider theme={theme}>
      <StylesProvider generateClassName={generateClassName}>
        {currentCustomerUser?.verified ? <PrivateRoutes /> : <PublicRoutes />}
      </StylesProvider>
    </CssVarsProvider>
  );
};
